import React from 'react';
import { PageSEO } from '../common/blog/elements/SEO';
import PageLayout from '../common/page-layout/PageLayout';
import { SectionHeader } from './section-header/SectionHeader';
import { Question } from './question/Question';

const FAQ = () => {
  return (
    <PageLayout>
      <>
        <PageSEO
          title={'FAQ - Limbiks'}
          description={'Frequently asked questions for Limbiks'}
        />{' '}
        <div className="container mx-auto rounded-lg p-8 py-24 shadow-md">
          <h2 className="mb-4 text-3xl font-semibold">
            Frequently Asked Questions
          </h2>
          <div className="py-4">
            <SectionHeader text={'Generating Flashcards'} />

            <Question
              question="What type of files can I upload?"
              answer="Flashcards can be generated from PDF (.pdf), Word Document
                (.docx), Text (.txt), PowerPoint (.pptx) File, JPEG (.jpg) and PNG (.png)"
            />

            <Question
              question="What if my file is really big?"
              answer="Limbiks can handle uploading files of any size. However, the
              number of pages processed is limited based on your current
              subscription level."
            />

            <Question
              question="Can I make flashcards from youtube videos?"
              answer="Yes! Click the red button and paste in the link to a video you want to create flashcards from."
            />

            <Question
              question="What languages are supported?"
              answer="Limbiks may have the best results with English, however, it also supports 21 other languages
                including Catalan, Chinese, Croatian, Danish, Dutch, Finnish, French,
                German, Greek, Italian, Japanese, Korean, Lithuanian,
                Macedonian, Polish, Portuguese, Romanian, Russian, Spanish,
                Swedish, and Ukranian.
              "
            />

            <Question
              question="How do I select specific pages or slides?"
              answer="Before generating, provide a comma separated list of page numbers or ranges of page numbers. For example, entering '1, 2, 4-7' will generate flashcards from pages 1, 2, 4, 5, 6, and 7."
            />

            <Question
              question="What style are the flashcards that get made?"
              answer="Limbiks can generate two types of flashcards for every language, fill in the blank and question and answer. "
            />

            <Question
              question="Why does it say my deck failed?"
              answer="This usually means Limbiks was not able to read the file uploaded.  There are a few reasons for this like corrupted files, password protected files, incorrect file encondings, etc."
            />

            <Question
              question="Why does my deck have 0 flashcards?"
              answer="Occasionally, files with lots of incomplete sentences and scattered text do provide enough information for Limbiks to generate flashcards.  Also, text inside of images on powerpoints and pdfs is not able to be processed yet.  You can double check if your text is able to be processed by Limbiks by trying to highlight text with your cursor."
            />

            <SectionHeader text={'Studying Flashcards'} />

            {/* Question 4 */}
            <Question
              question="How can I study my flashcards with Limbiks?"
              answer="Limbiks built in study tools lets flashcard  be studied as a traditional flashcard (click on the card to show the answer) or as a multiple choice question."
            />

            <Question
              question="How come the multiple choice answers don't make sense?"
              answer="Occasionally, Limbiks AI is not able to come up with good answer choices and Limbiks may show choices that don't make sense. As we continue to improve Limbiks, we are working to minimize how often this occurs and constantly provide high quality multiple choice questions."
            />

            <Question
              question="What do I do after I download the CSV?"
              answer="Almost every major flashcard tool has a way to import flashcards from a CSV file.  Please refer to the guides for your desired flashcard tool for the best method to import flashcards from a CSV."
            />

            <Question
              question="What is Anki? And what is that sync to Anki button?"
              answer="Anki is an extremly powerful flashcard tool and the primary study tool my wife used during medical school. Anki uses spaced repetition to help you memorize hundreds and thousands of flashcards over long periods of time.  There is an Anki plugin called AnkiConnect which allows Limbiks to instantly send your flashcards straight to Anki."
            />

            <Question
              question="Does the sync to Anki feature support Cloze flashcards?"
              answer="Yes! Fill in the blank flashcards will be imported into anki as Cloze style flashcards automatically."
            />

            <Question
              question="Can I modify or delete flashcards?"
              answer="Yes! Limbiks allows you to add, edit and delete any flashcards it creates.  This can be done while studying or from the View All / Edit page."
            />

            <Question
              question="Can I change the name of a deck?"
              answer="Yes! After opening a deck, click on the deck name in the top left corner and you will be able to edit the deck name."
            />

            <SectionHeader text={'Accounts and Subscriptions'} />

            <Question
              question="How do I delete my account and data?"
              answer="When signed into Limbiks, navigate to the account page by clicking the user icon in the top right corner.  Here you will see a delete account button which will delete your account and all data associated to your account."
            />

            <Question
              question="How do I cancel my subscription?"
              answer="When signed into Limbiks, navigate to the account page by clicking the user icon in the top right corner.  Here you will see a button called Manage Subscriptions which will launch a customer portal where you can cancel your subscription."
            />

            <Question
              question="What happens if I cancel my pro subscription before the end of the month?"
              answer="Your Limbiks Pro subscription will remain active until the end of your subscription term regardless of when you cancel your subscription."
            />

            <Question
              question="What does the reset date mean?"
              answer="The reset date is the date that your uploads remaining will reset to the full amount.  For a free subscription, it will reset to 10 uploads. For a pro subscription, it will reset to 100 uploads."
            />

            <Question
              question="Does the reset date work the same if I buy a monthly or annual subscription?"
              answer="Yes! The reset date will always be in one month increments from the date of your subscription purchase."
            />

            <Question
              question="How can I purchase a pro subscription?"
              answer="You can upgrade to pro from the account page or by clicking subscribe on the home page.  Limbiks pro is currently available in the United States, Canada, United Kingdom, European Union, Philippines, South Africa, New Zealand and Australia.  We are continously working on rolling out to more locations.  If you would like Limbiks Pro (more uploads and features) to become available in your country/region please let us know at support@limbiks.com."
            />

            <SectionHeader text={'General'} />

            <Question
              question="How do I give feedback?"
              answer="There is a feedback button at the top of the screen when signed in.  Feedback is the best way we can improve Limbiks and is greatly encouraged. You can also email us directly at support@limbiks.com"
            />

            <Question
              question="How can I help make Limbiks better?"
              answer="Providing feedback, sharing Limbiks with your friends, and purchasing a Limbiks Pro subscription are the best ways to help support Limbiks so it can continue to grow and improve."
            />
          </div>
        </div>
      </>
    </PageLayout>
  );
};

export default FAQ;
